import styled from "styled-components"

export const Title = styled.h2`
  margin-inline: auto;
  margin-left: 0;

  font-family: var(--ff-secondary);
  font-weight: 700;
  font-size: 1.25em;
  line-height: 1.875rem;

  text-transform: uppercase;

  @media (min-width: 40em) {
    line-height: 2.4375rem;
    font-size: 1.5em;
  }
`
